/**
 * A barra de estado: 30 px no rodapé, onde a tela diz o que acabou de
 * acontecer sem roubar espaço do trabalho.
 */

import type { ReactNode } from "react"

export function BarraDeEstado({ children, direita }: { children?: ReactNode; direita?: ReactNode }) {
  return (
    <div
      className="barra"
      style={{
        height: 30, flex: "0 0 30px", display: "flex", alignItems: "center", gap: 10,
        padding: "0 18px", background: "var(--surface)", borderTop: "1px solid var(--line)",
        fontSize: 11.5, color: "var(--txt2)", whiteSpace: "nowrap",
      }}
    >
      {children}
      <span style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>{direita}</span>
    </div>
  )
}
